import type { HierarchyPointNode } from '@visx/hierarchy'
import cx from 'classnames'

import { useTemplateNavigation } from '../../system/useTemplateNavigation'
import { TextRectangle } from '../shapes/TextRectangle'
import { TEXT_BOX_PADDING_X, TEXT_BOX_PADDING_Y } from './constants'
import type { TreeNode } from './types'

type Props = { node: HierarchyPointNode<TreeNode> }

export const SubTemplateTreeNode = ({ node }: Props) => {
  const navigate = useTemplateNavigation()
  return (
    <TextRectangle
      top={node.x}
      left={node.y}
      horizontalPadding={TEXT_BOX_PADDING_X}
      verticalPadding={TEXT_BOX_PADDING_Y}
      text={typeof node.data.id === 'symbol' ? '*' : node.data.id}
      rectClassName={cx('stroke-2', {
        'fill-subtemplateCurrent': Math.abs(node.data.depth) === 0,
        'fill-subtemplateChild': Math.abs(node.data.depth) === 1,
        'fill-subtemplateGrandChild': Math.abs(node.data.depth) >= 2,
        'stroke-subtemplateRoot stroke-3': node.data.root,
      })}
      groupClassName={
        typeof node.data.id === 'string'
          ? 'hover:opacity-90 cursor-pointer'
          : 'cursor-not-allowed'
      }
      onClick={() =>
        typeof node.data.id === 'string'
          ? navigate({
              templateId: node.data.id,
              layer: node.data.layer,
              block: node.data.block,
            })
          : undefined
      }
      rounded="md"
    >
      {({ width, height }) => (
        <text
          x={width / 2}
          y={height / 2}
          dominantBaseline="middle"
          textAnchor="middle"
          className="fill-amaze-inkBright"
          fontWeight={node.data.root ? 'bolder' : 'normal'}
        >
          {typeof node.data.id === 'symbol' ? '*' : node.data.id}
        </text>
      )}
    </TextRectangle>
  )
}
